import {
  animate,
  state,
  style,
  transition,
  trigger,
  query,
  animateChild,
} from '@angular/animations';

export const unfoldingAnimation = () => {
  return trigger('unfoldingAnimation', [
    state('in', style({ opacity: 1 })),

    transition(':enter', [style({ height: '0px' }), animate(300)]),

    transition(':leave', animate(300, style({ height: '0px' }))),
  ]);
};

export const expandedAnimation = () => {
  return trigger('unfoldingAnimation', [
    state('in', style({})),

    transition(':enter', [style({ height: '0px', opacity: 0 }), animate(300)]),
  ]);
};

export const fadeAnimation = () => {
  return trigger('enterTrigger', [
    state('fadeIn', style({ opacity: '1' })),
    transition('void => *', [style({ opacity: '0' }), animate('300ms')]),
  ]);
};

export const routeAnimation = trigger('routeAnimations', [
  transition('* <=> *', [
    style({ opacity: '0' }),
    query(':enter, :leave', animateChild(), { optional: true }),
    animate('200ms'),
  ]),
]);

export const showAnimation = () => {
  return trigger('unfoldingAnimation', [
    state('unfolding', style({ opacity: 1 })),

    transition(':enter', [style({ opacity: '0' }), animate(200)]),

    transition(':leave', animate(200, style({ opacity: '0' }))),
  ]);
};
